<button type="button" openDialog (click)="openModal($event.target.getBoundingClientRect().top)">
    <span>{{ 'MENU.SEARCH_PLACEHOLDER' | translate }}</span>
    <app-svg use="search"></app-svg>
</button>
<dialog [modal]="true" [id]="modalId" (openedEvent)="focus()">
    <button closeDialog></button>
    <form id="header-search"
          (submit)="goToSearch($event)">
        <input type="search"
               (input)="search($event)"
               required
               [placeholder]="'MENU.SEARCH_PLACEHOLDER' | translate"
               name="searchTerms">
        <input type="hidden"
               name="from"
               value="0">
        <input type="hidden"
               name="size"
               value="10">
        <button type="submit"
                [attr.aria-label]="'MENU.SEARCH_SUBMIT' | translate">
            <app-svg use="search"></app-svg>
        </button>
    </form>
    @if(result$ | async; as result) {
        @if(result.length > 0) {
            <div class="section">
                @for (product of result; track product.id) {
                    <app-product-card [product]="product"
                    ga4SelectItem
                    [items]="[product] | mapGA4Items"
                    ></app-product-card>
                }
            </div>
        }
        @else {
            <layout-block-list-outlet [list]="layout"></layout-block-list-outlet>
        }
    } @else {
        <layout-block-list-outlet [list]="layout"></layout-block-list-outlet>
    }

</dialog>
